<template>
  <div class="">
    <img class="errorPic" src="/static/images/maintain.png"  alt="">
    <div class="text-cent">
      <p class="text-left col-999">{{datas}}</p>
    </div>

  </div>
</template>

<script>
  export default {
    name: "error",
    data () {
      return {
        datas:'',
      }
    },
    created(){
    },
    methods: {

      goback:function () {
        history.go(-1)
      },
      gohome:function () {
        this.$router.push({path:'/'})
      },
      getdatas:function () {
        var mallid=localStorage.getItem("mallid");
        this.$api.get('/sys/maintain', {id_example:mallid}, res => {
          if (res.data.code== '100') {
              if(res.data.data.status==0){
                this.$router.push({ name: 'Home' })
              }else{
                this.datas = res.data.data.information
              }

          }
        })
      },
    },
    mounted () {
        this.getdatas()
    },
  }
</script>

<style lang="less" scoped>
.errorPic{
    width: 70%;
    margin-left: 15%;
    margin-top: 25%;
    margin-bottom: 5%;
  }
  p{
    padding: 0px 45px;
    margin-top: 3px;
  }
  .sorrryAbout{
    margin-top: 40px;
    margin-bottom: 10px;
    padding: 0px 15px;
    i{
      vertical-align: middle;
      font-size: 20px;
      margin-right: 10px;
      position: relative;
      top:-1px;
    }
  }
  .van-button {
    height: 40px;
    line-height: 38px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/activity/maintain.vue